var _path, _mask;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6075 6.17706C14.218 6.55045 14.218 7.15882 14.6075 7.53218L17.8685 10.6565H3.25523C2.71315 10.6565 2.26904 11.0822 2.26904 11.6101V11.8492C2.26904 12.377 2.71315 12.8027 3.25523 12.8027H17.8692L14.6075 15.9295C14.218 16.3029 14.218 16.9112 14.6075 17.2846L14.7846 17.4543C15.1693 17.8232 15.7892 17.8232 16.1739 17.4543L21.4388 12.4097C21.8284 12.0362 21.8284 11.4279 21.4389 11.0545L16.1738 6.00959C15.7879 5.63967 15.1706 5.63726 14.7846 6.00732L14.6075 6.17706Z",
    fill: "#B6BEBF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 20,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6075 6.17706C14.218 6.55045 14.218 7.15882 14.6075 7.53218L17.8685 10.6565H3.25523C2.71315 10.6565 2.26904 11.0822 2.26904 11.6101V11.8492C2.26904 12.377 2.71315 12.8027 3.25523 12.8027H17.8692L14.6075 15.9295C14.218 16.3029 14.218 16.9112 14.6075 17.2846L14.7846 17.4543C15.1693 17.8232 15.7892 17.8232 16.1739 17.4543L21.4388 12.4097C21.8284 12.0362 21.8284 11.4279 21.4389 11.0545L16.1738 6.00959C15.7879 5.63967 15.1706 5.63726 14.7846 6.00732L14.6075 6.17706Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnector);
export default __webpack_public_path__ + "static/media/connector.26c5a53c.svg";
export { ForwardRef as ReactComponent };